import moment from "moment";
import "moment/locale/es";
import { dineroDisabledMask } from "../Components/Items";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";
import BIWO_LOGO_FOOTER from "../Components/PdfComponents/componentsv2.0/biwoLogoFooter";

moment.locale("es");

const footerBiwo = {
  stack: [
    { text: "Hecho por", fontSize: 7, color: "#999999", alignment: "center", margin: [0, 0, 0, 1] },
    { image: "logoBiwo", width: 50, alignment: "center" },
  ],
  margin: [0, 4, 0, 6],
};

const esImagenPdfSoportada = (s) =>
  typeof s === "string" && /^data:image\/(png|jpe?g);base64,/i.test(s);

const BLANK_PNG =
  "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==";

const COLORES_PDF = [
  "#4e79a7", "#f28e2b", "#e15759", "#76b7b2",
  "#59a14f", "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ac",
];

const borderLayout = {
  hLineWidth: () => 1,
  vLineWidth: () => 1,
  hLineColor: () => "#adaaaa",
  vLineColor: () => "#adaaaa",
  hLineStyle: (i, node) => {
    if (i === 0 || i === node.table.body.length) return null;
    return { dash: { length: 2, space: 1 } };
  },
  vLineStyle: (i, node) => {
    if (i === 0 || i === node.table.widths.length) return null;
    return { dash: { length: 2 } };
  },
};

const tableLayout = {
  fillColor: (rowIndex, node) => {
    if (rowIndex === 0) return "#cccccc";
    return rowIndex % 2 === 0 ? "#f0f0f0" : "#ffffff";
  },
  hLineWidth: () => 0.5,
  vLineWidth: () => 0.5,
  hLineColor: () => "#cccccc",
  vLineColor: () => "#cccccc",
};

const buildBarras = (datos, getVal, getLabel, fmtFn = String) => {
  if (!datos || datos.length === 0) {
    return { text: "Sin datos suficientes para la gráfica.", style: "textoChico", italics: true, margin: [0, 4, 0, 10] };
  }
  const maxV = Math.max(...datos.map(getVal), 1);
  const W = 300, H = 12, G = 6;
  return {
    columns: [
      {
        width: W,
        canvas: datos.map((d, i) => ({
          type: "rect",
          x: 0,
          y: i * (H + G),
          w: Math.max(2, Math.round((getVal(d) / maxV) * W)),
          h: H,
          color: COLORES_PDF[i % COLORES_PDF.length],
          r: 2,
        })),
      },
      {
        width: "*",
        margin: [8, 0, 0, 0],
        stack: datos.map((d) => ({
          text: `${getLabel(d)}  —  ${fmtFn(getVal(d))}`,
          style: "textoTabla",
          color: "#444",
          margin: [0, 2, 0, G - 2],
        })),
      },
    ],
    margin: [0, 4, 0, 12],
  };
};

const encabezado = (empresa, titulo, fechaInicio, fechaFin, extraLineas = []) => {
  const terceraColumna = {
    border: [false, false, false, false],
    table: {
      headerRows: 1,
      widths: ["100%"],
      body: [
        [{ text: titulo, style: "subheader", alignment: "center" }],
        [
          {
            text: `${moment(fechaInicio).format("DD/MM/YYYY")} — ${moment(fechaFin).format("DD/MM/YYYY")}`,
            style: "textoChico",
            alignment: "center",
          },
        ],
        ...extraLineas.map((t) => [{ text: t, style: "textoChico", alignment: "center" }]),
        [{ text: "Impreso: " + moment().format("ll"), style: "textoChico", alignment: "center" }],
      ],
    },
    layout: "noBorders",
  };
  return {
    style: "tableExample",
    table: {
      widths: ["18%", "52%", "30%"],
      body: [[...HeaderEmpresaCard(empresa || {}, false, false, terceraColumna)]],
    },
    layout: "noBorders",
  };
};

const cabecera = (arr) => arr.map((t) => ({ text: t, style: "tituloTabla", alignment: "center" }));
const celda = (t, align = "left") => ({ text: t, style: "textoTabla", alignment: align });

const contenidoFlota = (values) => {
  const { resumen } = values; // filas por camión
  const filas = resumen.map((r) => [
    celda(r.nombre),
    celda(String(r.numCargas), "center"),
    celda(r.totalLitros.toFixed(2), "right"),
    celda(dineroDisabledMask(r.gastoTotal), "right"),
    celda(r.totalKm.toFixed(1), "right"),
    celda(r.kmPorLitro > 0 ? r.kmPorLitro.toFixed(2) : "—", "right"),
    celda(r.totalKm > 0 ? dineroDisabledMask(r.costoPorKm) : "—", "right"),
  ]);
  return [
    { text: "Resumen por camión", style: "subheader", margin: [0, 8, 0, 4] },
    {
      style: "tableExample",
      table: {
        widths: ["24%", "8%", "13%", "16%", "13%", "13%", "13%"],
        body: [cabecera(["Camión", "Cargas", "Litros", "Gasto", "KM", "km/L", "Costo/km"]), ...filas],
      },
      layout: tableLayout,
    },
    { text: "Rendimiento (km/L) por camión", style: "subheader", margin: [0, 10, 0, 2] },
    buildBarras(
      resumen.filter((r) => r.kmPorLitro > 0),
      (r) => r.kmPorLitro,
      (r) => r.nombre,
      (v) => `${v.toFixed(2)} km/L`
    ),
    { text: "Gasto de combustible por camión", style: "subheader", margin: [0, 6, 0, 2] },
    buildBarras(
      resumen.filter((r) => r.gastoTotal > 0),
      (r) => r.gastoTotal,
      (r) => r.nombre,
      (v) => dineroDisabledMask(v)
    ),
  ];
};

const contenidoCamion = (values) => {
  const { porChofer, registros, stats } = values;
  const filasChofer = porChofer.map((c) => [
    celda(c.chofer),
    celda(String(c.numTramos), "center"),
    celda(c.km.toFixed(1), "right"),
    celda(c.litros.toFixed(2), "right"),
    celda(c.rendimiento > 0 ? c.rendimiento.toFixed(2) : "—", "right"),
  ]);
  const filasReg = registros.map((r) => [
    celda(r.fecha ? moment(r.fecha).format("DD/MM/YYYY") : "—"),
    celda((r.kmOdometro || 0).toLocaleString("es-MX"), "right"),
    celda((r.litros || 0).toFixed(2), "right"),
    celda((r.tipoCombustible || "").toUpperCase(), "center"),
    celda(dineroDisabledMask(r.precioPorLitro), "right"),
    celda(dineroDisabledMask(r.total), "right"),
    celda(r.kmRecorridos != null ? r.kmRecorridos.toFixed(1) : "—", "right"),
    celda(r.rendimiento != null ? r.rendimiento.toFixed(2) : "—", "right"),
    celda(r.choferNombre || "—"),
  ]);
  return [
    {
      style: "tableExample",
      table: {
        widths: ["25%", "25%", "25%", "25%"],
        body: [
          cabecera(["Total Litros", "Gasto Total", "KM Totales", "km/L Global"]),
          [
            celda(stats.totalLitros.toFixed(2), "center"),
            celda(dineroDisabledMask(stats.gastoTotal), "center"),
            celda(stats.totalKm.toFixed(1), "center"),
            celda(stats.kmPorLitro > 0 ? stats.kmPorLitro.toFixed(2) + " km/L" : "—", "center"),
          ],
        ],
      },
      layout: borderLayout,
    },
    { text: "Consumo por chofer", style: "subheader", margin: [0, 10, 0, 4] },
    {
      style: "tableExample",
      table: {
        widths: ["40%", "12%", "16%", "16%", "16%"],
        body: [cabecera(["Chofer", "Tramos", "KM", "Litros", "km/L"]), ...filasChofer],
      },
      layout: tableLayout,
    },
    { text: "Rendimiento (km/L) por chofer", style: "subheader", margin: [0, 8, 0, 2] },
    buildBarras(
      porChofer.filter((c) => c.rendimiento > 0),
      (c) => c.rendimiento,
      (c) => c.chofer,
      (v) => `${v.toFixed(2)} km/L`
    ),
    { text: "Registros del período", style: "subheader", margin: [0, 8, 0, 4] },
    {
      style: "tableExample",
      table: {
        widths: ["11%", "12%", "9%", "9%", "11%", "11%", "10%", "9%", "18%"],
        body: [
          cabecera(["Fecha", "Odómetro", "Litros", "Tipo", "Precio/L", "Total", "KM Rec.", "km/L", "Chofer"]),
          ...filasReg,
        ],
      },
      layout: tableLayout,
    },
    {
      text: "* El km/L de cada tramo se atribuye al chofer de la carga inicial; parte del recorrido pudo hacerlo otro conductor.",
      style: "nota",
      margin: [0, 8, 0, 0],
    },
  ];
};

const contenidoAnomalias = (values) => {
  const { anomalias, umbral } = values;
  const filas = anomalias.map((a) => [
    celda(a.proyectoNombre),
    celda(a.fecha ? moment(a.fecha).format("DD/MM/YYYY") : "—"),
    celda(a.choferNombre || "—"),
    celda(a.rendimiento != null ? a.rendimiento.toFixed(2) : "—", "right"),
    celda(a.baseline > 0 ? a.baseline.toFixed(2) : "—", "right"),
    {
      text: `${a.desviacionPct > 0 ? "+" : ""}${a.desviacionPct.toFixed(1)}%`,
      style: "textoTabla",
      alignment: "right",
      color: a.tipo === "Bajo" ? "#c0392b" : "#8e44ad",
      bold: true,
    },
    {
      text: a.tipo,
      style: "textoTabla",
      alignment: "center",
      color: a.tipo === "Bajo" ? "#c0392b" : "#8e44ad",
      bold: true,
    },
  ]);
  return [
    {
      text: `Cargas cuyo rendimiento se desvía más de ${umbral}% del promedio de su camión`,
      style: "subheader",
      margin: [0, 8, 0, 4],
    },
    anomalias.length === 0
      ? { text: "No se detectaron anomalías con el umbral seleccionado.", style: "textoChico", italics: true }
      : {
          style: "tableExample",
          table: {
            widths: ["22%", "12%", "22%", "12%", "12%", "10%", "10%"],
            body: [
              cabecera(["Camión", "Fecha", "Chofer", "km/L", "Prom.", "Desv.", "Alerta"]),
              ...filas,
            ],
          },
          layout: tableLayout,
        },
    {
      text:
        "Criterio: \"Bajo\" = rinde menos de lo normal (posible fuga, robo o mayor consumo). " +
        "\"Alto\" = rinde de más (posible error de captura de odómetro o litros).",
      style: "nota",
      margin: [0, 8, 0, 0],
    },
  ];
};

const reporteCargasCombustiblePdf = (values) => {
  const { tipo, empresa, fechaInicio, fechaFin } = values;

  let titulo = "Reporte de Consumo";
  let extra = [];
  let content = [];

  if (tipo === "flota") {
    titulo = "Consumo por Camión (Flota)";
    content = contenidoFlota(values);
  } else if (tipo === "camion") {
    titulo = "Detalle de Consumo";
    extra = [values.camionNombre || ""];
    content = contenidoCamion(values);
  } else if (tipo === "anomalias") {
    titulo = "Detección de Anomalías";
    content = contenidoAnomalias(values);
  }

  return {
    content: [encabezado(empresa, titulo, fechaInicio, fechaFin, extra), ...content],
    footer: footerBiwo,
    images: {
      logo: esImagenPdfSoportada(empresa?.logo?.base64Completa) ? empresa.logo.base64Completa : BLANK_PNG,
      logoBiwo: BIWO_LOGO_FOOTER,
    },
    styles: {
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      subheader: { fontSize: 10, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tituloTabla: { fontSize: 8, bold: true, alignment: "center" },
      textoTabla: { fontSize: 8 },
      textoChico: { fontSize: 8 },
      nota: { fontSize: 7, italics: true, color: "#888888" },
    },
    pageSize: "LETTER",
    pageOrientation: "landscape",
    pageMargins: [20, 20, 20, 50],
  };
};

export default reporteCargasCombustiblePdf;
